// Reference: packages/editor/editor-plugin-ai/src/ui/icons/actions/insertAtOrBelow.tsx
import React from 'react';

import AKIcon, { type IconProps as AKIconProps, type CustomGlyphProps } from '@atlaskit/icon';
import AKRetryIcon from '@atlaskit/icon/core/retry';
import { token } from '@atlaskit/tokens';

const IconGlyph = (props: CustomGlyphProps) => (
	<svg
		width={14}
		height="100%"
		viewBox="0 0 14 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		className={props.className}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
		style={props.style}
		aria-label={props['aria-label']}
		aria-hidden={props['aria-hidden']}
		focusable={props.focusable}
		role={props.role}
		tabIndex={props.tabIndex}
		data-testid={props['data-testid']}
		id={props.id}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0 7C0 3.13401 3.13401 0 7 0C9.2317 0 11.2185 1.0441 12.5 2.66966V0H14V5C14 5.41421 13.6642 5.75 13.25 5.75H8.5V4.25H11.7644C10.8131 2.60552 9.03498 1.5 7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5C9.73732 12.5 12.0088 10.4996 12.4299 7.88092L13.9109 8.11908C13.3747 11.4533 10.4855 14 7 14C3.13401 14 0 10.866 0 7Z"
			fill="currentColor"
		/>
	</svg>
);

export const RetryIcon = () => (
	<AKRetryIcon
		label=""
		spacing="spacious"
		LEGACY_fallbackIcon={(props: AKIconProps) => (
			<AKIcon
				glyph={IconGlyph}
				label={props.label}
				size={props.size}
				primaryColor={props.primaryColor}
				secondaryColor={props.secondaryColor}
				testId={props.testId}
			/>
		)}
		LEGACY_secondaryColor={token('color.icon')}
	/>
);
